import { serErrDebugH, jsonReplacerBigintSafeF } from './serErrDebugAI.mts';
let _monorepoPrefix;
const getMonorepoPrefix = () => _monorepoPrefix || (_monorepoPrefix = import.meta.url.replace(/pt0\/sharedF\/throwErrorF\/sharedErrF\.mts$/, ''));
// spread into a debugH to suppress the stacktrace for user-facing blocker errors
// (message is actionable; the trace is noise). _maxFrames is stripped from printed output below.
export const userBlockerDebugH = { _maxFrames: 0 };
export class PtErr extends Error {
    constructor(message, uniqDebugH, dumpDebugH) {
        super(message);
        // non-enumerable to avoid duplicate printing by Node's error inspector
        Object.defineProperty(this, 'uniqDebugH', { value: serErrDebugH(uniqDebugH), enumerable: false, writable: true });
        Object.defineProperty(this, 'dumpDebugH', { value: serErrDebugH(dumpDebugH), enumerable: false, writable: true });
        void this.stack;
    }
}
const origPrepareStackTrace = Error.prepareStackTrace;
Error.prepareStackTrace = (err, callSites) => {
    if (!(err instanceof PtErr)) {
        return origPrepareStackTrace ? origPrepareStackTrace(err, callSites) : `${err.name}: ${err.message}\n` + callSites.map(s => `    at ${s}`).join('\n');
    }
    const monorepoPrefix = getMonorepoPrefix();
    const isInternalFrame = (shortPath) => shortPath.includes('/throwErrorF/');
    const callerSite = callSites.find(site => {
        const fileName = site.getFileName() || '';
        if (!fileName.startsWith(monorepoPrefix) || fileName.includes('[eval'))
            return false;
        return !isInternalFrame(fileName.replace(monorepoPrefix, ''));
    });
    if (callerSite) {
        const shortPath = (callerSite.getFileName() || '').replace(monorepoPrefix, '');
        const fnName = callerSite.getFunctionName() || '<anonymous>';
        Object.defineProperty(err, 'throwLocation', { value: `${shortPath}:${fnName}`, enumerable: false, writable: true, configurable: true });
    }
    const monorepoFrames = callSites
        .map(site => {
        const fileName = site.getFileName() || '';
        if (!fileName.startsWith(monorepoPrefix) || fileName.includes('[eval'))
            return null;
        const shortPath = fileName.replace(monorepoPrefix, '');
        const fnName = site.getFunctionName() || '<anonymous>';
        return `    at ${fnName} (${shortPath}:${site.getLineNumber()})`;
    })
        .filter(Boolean);
    const maxFrames = err.uniqDebugH?._maxFrames ?? Infinity;
    const shownFrames = monorepoFrames.slice(0, maxFrames);
    const parts = [`PtErr: ${err.message}`, ...shownFrames];
    const { _maxFrames, ...debugWithoutMaxFrames } = err.uniqDebugH || {};
    if (Object.keys(debugWithoutMaxFrames).length > 0)
        parts.push(`  uniqDebugH: ${JSON.stringify(debugWithoutMaxFrames, jsonReplacerBigintSafeF)}`);
    return parts.join('\n');
};
export const throPtErr = (...props) => {
    throw new PtErr(...props);
};
